import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { InvoiceForm } from "@/features/invoices/components/invoice-form";
import { z } from "zod";

const invoiceSearchSchema = z.object({
  customerId: z.string().optional(),
});

export const Route = createFileRoute("/(app)/dashboard/invoices/new")({
  component: NewInvoicePage,
  validateSearch: invoiceSearchSchema,
});

function NewInvoicePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { customerId } = Route.useSearch();

  const handleSuccess = () => {
    navigate({ to: "/dashboard/invoices" });
  };

  return (
    <div className="w-full max-w-full space-y-4 md:space-y-6 overflow-hidden">
      <h1 className="text-2xl font-bold md:text-3xl">{t('invoices.form.newInvoiceTitle')}</h1>
      <InvoiceForm onSuccess={handleSuccess} preselectedCustomerId={customerId} />
    </div>
  );
}
